import { defineComponent, ref, onMounted, onUnmounted, unref, openBlock, createElementBlock, normalizeClass } from 'vue';
import { AudioPlayerSingleton, AudioPlayerStatus } from '@ssml-editor/modules';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "player",
  props: {
    src: {},
    playClassName: { default: "se-player-play" },
    pauseClassName: { default: "se-player-pause" }
  },
  emits: ["statuschange"],
  setup(__props, { emit: __emit }) {
    const playerSrc = ref();
    const playerStatus = ref();
    const emit = __emit;
    function playHandler() {
      AudioPlayerSingleton.play({ src: __props.src });
    }
    function pauseHandler() {
      AudioPlayerSingleton.pause();
    }
    function playerStatusChangeHandler(status) {
      playerSrc.value = AudioPlayerSingleton.options?.src;
      playerStatus.value = status;
      emit("statuschange", status);
    }
    onMounted(() => {
      AudioPlayerSingleton.on("statuschange", playerStatusChangeHandler);
    });
    onUnmounted(() => {
      AudioPlayerSingleton.stop().unload();
      AudioPlayerSingleton.off("statuschange", playerStatusChangeHandler);
    });
    return (_ctx, _cache) => {
      return playerSrc.value === __props.src && (playerStatus.value === unref(AudioPlayerStatus).LOADING || playerStatus.value === unref(AudioPlayerStatus).PLAYING) ? (openBlock(), createElementBlock("i", {
        key: 0,
        class: normalizeClass(["iconfont-ssml-editor icon-ssml-editor-zanting", __props.pauseClassName]),
        onClick: ($event) => pauseHandler()
      }, null, 10, ["onClick"])) : (openBlock(), createElementBlock("i", {
        key: 1,
        class: normalizeClass(["iconfont-ssml-editor icon-ssml-editor-bofang", __props.playClassName]),
        onClick: ($event) => playHandler()
      }, null, 10, ["onClick"]));
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=player.vue.js.map
